import { NgClass } from '@angular/common';
import { Component, inject, Input, OnInit } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Checkbox } from 'primeng/checkbox';
import { InputText } from 'primeng/inputtext';
import { PickList, PickListMoveAllToSourceEvent, PickListMoveAllToTargetEvent, PickListMoveToSourceEvent, PickListMoveToTargetEvent } from 'primeng/picklist';
import { Tooltip } from 'primeng/tooltip';
import { HelperService } from '../../../../core/services/helper.service';
import { I18nService } from '../../../../core/services/i18n.service';
import { SpsCustomIconComponent } from '../../../../custom/components/sps-custom-icon/sps-custom-icon.component';
import { PaymentPageData } from '../../../interfaces/payment-page/payment-page-data';
import { PaymentData } from '../../../interfaces/payment/payment-data';

@Component({
  selector: 'add-form-payment-page',
  imports: [
    InputText,
    ReactiveFormsModule,
    FormsModule,
    Checkbox,
    PickList,
    SpsCustomIconComponent,
    Tooltip,
    NgClass
  ],
  templateUrl: './add-form-payment-page.component.html'
})
export class AddFormPaymentPageComponent implements OnInit {

  @Input() paymentPageData: PaymentPageData;
  @Input() paymentMethodsList: PaymentData[];


  public i18n = inject(I18nService);
  public helperService = inject(HelperService);

  isValidMail: boolean = true;

  /**
   * payment list parameters
   */
  availablePaymentMethods: PaymentData[];
  selectedPaymentMethods: PaymentData[];

  ngOnInit() {
    // Filter Chargeback Cards
    let cleanPaymentMethodsList: PaymentData[] = this.paymentMethodsList;
    cleanPaymentMethodsList = cleanPaymentMethodsList.filter(paymentMethod => !paymentMethod.isChargebackCard)
    this.availablePaymentMethods = cleanPaymentMethodsList.filter(paymentMethod => !this.paymentPageData.paymentTypeIds.includes(paymentMethod.id));
    this.selectedPaymentMethods = cleanPaymentMethodsList.filter(paymentMethod => this.paymentPageData.paymentTypeIds.includes(paymentMethod.id));
  }

  /**
   * add single payment-method
   * @param event
   */
  addPaymentMethod(event: PickListMoveToSourceEvent) {
    event.items.map(item => {
      this.paymentPageData.paymentTypeIds.push(item.id.toString());
    });
  }

  /**
   * add all available payment-methods
   * @param event
   */
  addPaymentMethods(event: PickListMoveAllToSourceEvent) {
    event.items.map(item => {
      this.paymentPageData.paymentTypeIds.push(item.id);
    });
  }

  /**
   * remove single payment method
   * @param event
   */
  removePaymentMethod(event: PickListMoveToTargetEvent) {
    event.items.map(item => {
      this.paymentPageData.paymentTypeIds = this.paymentPageData.paymentTypeIds.filter(id => id !== item.id);
    })
  }

  /**
   * remove all selected payment-methods
   * @param event
   */
  removePaymentMethods(event: PickListMoveAllToTargetEvent) {
    event.items.map(item => {
      this.paymentPageData.paymentTypeIds = this.paymentPageData.paymentTypeIds.filter(id => id !== item.id);
    })
  }

  /**
   * show hint if eMail is invalid
   * @protected
   */
  protected validateEmail() {
    this.isValidMail = true;
    if (this.paymentPageData?.accessibilityEMail && this.paymentPageData?.accessibilityEMail.length > 0  && !this.helperService.isValidEmail(this.paymentPageData?.accessibilityEMail)) {
      this.isValidMail = false;
    }
  }

}
